export const SHIPS = [
    { id: 'santisima-trinidad', name: 'Santísima Trinidad', rate: 1, decks: 4, guns: 144, mass: 4805 },
    { id: 'l-ocean', name: "L'Océan", rate: 1, decks: 4, guns: 126, mass: 5036 },
    { id: 'victory-1765-i', name: 'Victory 1765 (i)', rate: 1, decks: 4, guns: 118, mass: 4281 },
    { id: 'victory', name: 'Victory', rate: 1, decks: 4, guns: 112, mass: 4281 },
    { id: 'christian', name: 'Christian', rate: 2, decks: 4, guns: 96, mass: 3088 },
    { id: 'le-bucentaure', name: 'Le Bucentaure', rate: 2, decks: 3, guns: 90, mass: 3839 },
    { id: 'st-pavel', name: 'St. Pavel', rate: 2, decks: 4, guns: 84, mass: 3231 },
    { id: 'implacable', name: 'Implacable', rate: 3, decks: 4, guns: 98, mass: 3496 },
    { id: 'redoutable-i', name: 'Redoutable (i)', rate: 3, decks: 3, guns: 88, mass: 3531 },
    { id: 'admiraal-de-ruyter', name: 'Admiraal de Ruyter', rate: 3, decks: 3, guns: 82, mass: 3238 },
    { id: '3rd-rate', name: '3rd Rate', rate: 3, decks: 3, guns: 78, mass: 2963 },
    { id: 'bellona', name: 'Bellona', rate: 3, decks: 3, guns: 78, mass: 2963 },
    { id: 'wasa', name: 'Wasa', rate: 3, decks: 3, guns: 74, mass: 2000 },
    { id: 'constitution', name: 'Constitution', rate: 3, decks: 2, guns: 60, mass: 2741 },
    { id: 'uss-united-states', name: 'USS United States', rate: 3, decks: 2, guns: 58, mass: 2594 },
    { id: 'wapen-von-hamburg', name: 'Wapen von Hamburg', rate: 4, decks: 4, guns: 76, mass: 1811 },
    { id: 'rattvisan-i', name: 'Rättvisan (i)', rate: 4, decks: 3, guns: 70, mass: 2000 },
    { id: 'agamemnon', name: 'Agamemnon', rate: 4, decks: 3, guns: 68, mass: 1934 },
    { id: 'ingermanland', name: 'Ingermanland', rate: 4, decks: 3, guns: 68, mass: 1688 },
    { id: 'leopard-i', name: 'Leopard (i)', rate: 4, decks: 3, guns: 56, mass: 1733 },
    { id: 'indefatigable', name: 'Indefatigable', rate: 4, decks: 2, guns: 48, mass: 1927 },
    { id: 'trincomalee', name: 'Trincomalee', rate: 5, decks: 2, guns: 54, mass: 1490 },
    { id: 'endymion', name: 'Endymion', rate: 5, decks: 2, guns: 52, mass: 1662 },
    { id: 'diana', name: 'Diana', rate: 5, decks: 2, guns: 48, mass: 1487 },
    { id: 'diana-i', name: 'Diana (i)', rate: 5, decks: 2, guns: 48, mass: 1487 },
    { id: 'l-hermione-i', name: "L'Hermione (i)", rate: 5, decks: 2, guns: 46, mass: 1350 },
    { id: 'pandora-i', name: 'Pandora (i)', rate: 5, decks: 3, guns: 46, mass: 796 },
    { id: 'santa-cecilia', name: 'Santa Cecilia', rate: 5, decks: 2, guns: 46, mass: 1158 },
    { id: 'surprise', name: 'Surprise', rate: 5, decks: 2, guns: 44, mass: 780 },
    { id: 'essex', name: 'Essex', rate: 5, decks: 2, guns: 40, mass: 1054 },
    { id: 'frigate', name: 'Frigate', rate: 5, decks: 2, guns: 40, mass: 901 },
    { id: 'hercules-i', name: 'Hercules (i)', rate: 5, decks: 3, guns: 40, mass: 589 },
    { id: 'la-belle-poule', name: 'La Belle-Poule', rate: 5, decks: 2, guns: 40, mass: 1070 },
    { id: 'pirate-frigate', name: 'Pirate Frigate', rate: 5, decks: 2, guns: 40, mass: 901 },
    { id: 'le-gros-ventre-refit', name: 'Le Gros Ventre Refit', rate: 5, decks: 2, guns: 38, mass: 1231 },
    { id: 'la-renommee', name: 'La Renommée', rate: 5, decks: 2, guns: 32, mass: 865 },
    { id: 'hulk-indiaman', name: 'Hulk Indiaman', rate: 5, decks: 2, guns: 30, mass: 1613 },
    { id: 'indiaman', name: 'Indiaman', rate: 5, decks: 2, guns: 30, mass: 1613 },
    { id: 'cerberus', name: 'Cerberus', rate: 5, decks: 1, guns: 28, mass: 745 },
    { id: 'le-gros-ventre', name: 'Le Gros Ventre', rate: 5, decks: 1, guns: 20, mass: 1231 },
    { id: 'le-requin-i', name: 'Le Requin (i)', rate: 6, decks: 1, guns: 30, mass: 587 },
    { id: 'rattlesnake-heavy', name: 'Rattlesnake Heavy', rate: 6, decks: 2, guns: 28, mass: 489 },
    { id: 'rookie-snow', name: 'Rookie Snow', rate: 6, decks: 2, guns: 26, mass: 257 },
    { id: 'snow', name: 'Snow', rate: 6, decks: 2, guns: 26, mass: 257 },
    { id: 'traders-snow', name: 'Traders Snow', rate: 6, decks: 2, guns: 26, mass: 257 },
    { id: 'prince-de-neufchatel', name: 'Prince de Neufchâtel', rate: 6, decks: 2, guns: 24, mass: 348 },
    { id: 'niagara', name: 'Niagara', rate: 6, decks: 1, guns: 22, mass: 410 },
    { id: 'mercury', name: 'Mercury', rate: 6, decks: 1, guns: 20, mass: 489 },
    { id: 'navy-brig', name: 'Navy Brig', rate: 6, decks: 1, guns: 20, mass: 550 },
    { id: 'rattlesnake', name: 'Rattlesnake', rate: 6, decks: 1, guns: 20, mass: 333 },
    { id: 'brig', name: 'Brig', rate: 6, decks: 1, guns: 18, mass: 550 },
    { id: 'traders-brig', name: 'Traders Brig', rate: 6, decks: 1, guns: 18, mass: 659 },
    { id: 'mortar-brig', name: 'Mortar Brig', rate: 6, decks: 1, guns: 16, mass: 550 },
    { id: 'basic-cutter', name: 'Basic Cutter', rate: 7, decks: 1, guns: 12, mass: 220 },
    { id: 'cutter', name: 'Cutter', rate: 7, decks: 1, guns: 12, mass: 220 },
    { id: 'pickle', name: 'Pickle', rate: 7, decks: 1, guns: 12, mass: 262 },
    { id: 'privateer', name: 'Privateer', rate: 7, decks: 1, guns: 12, mass: 228 },
    { id: 'traders-cutter', name: 'Traders Cutter', rate: 7, decks: 1, guns: 12, mass: 220 },
    { id: 'yacht-i', name: 'Yacht (i)', rate: 7, decks: 1, guns: 12, mass: 220 },
    { id: 'yacht-silver-i', name: 'Yacht Silver (i)', rate: 7, decks: 1, guns: 12, mass: 220 },
    { id: 'basic-lynx', name: 'Basic Lynx', rate: 7, decks: 1, guns: 8, mass: 222 },
    { id: 'lynx', name: 'Lynx', rate: 7, decks: 1, guns: 8, mass: 222 },
    { id: 'traders-lynx', name: 'Traders Lynx', rate: 7, decks: 1, guns: 8, mass: 222 },
    { id: 'gunboat', name: 'GunBoat', rate: 7, decks: 0, guns: 2, mass: 73 },
];
const HEAVIEST = Math.max(...SHIPS.map((s) => s.mass));
/**
 * Pure: how long this ship is next to the heaviest one (1), from the game's
 * masses — ships of the age of sail share broadly similar proportions, so
 * mass grows with the cube of length. Used to draw every ship to one scale.
 */
export function shipLengthScale(ship) {
    return Math.cbrt(ship.mass / HEAVIEST);
}
const byId = new Map(SHIPS.map((s) => [s.id, s]));
/** The ship with this id, or undefined for an unknown id. */
export function shipById(id) {
    return byId.get(id);
}
/** "1st rate", "2nd rate", ... */
export function rateLabel(rate) {
    const suffix = rate === 1 ? 'st' : rate === 2 ? 'nd' : rate === 3 ? 'rd' : 'th';
    return `${rate}${suffix} rate`;
}
//# sourceMappingURL=ships.js.map